module.exports = __webpack_public_path__ + "img/greenBook.0ede43ec.png";